/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormularioResolucionesFacturacionesCV from './controladorVista/formularioResolucionesFacturacionesCV';
import TablaResolucionesFacturacionesCV from './controladorVista/tablaResolucionesFacturacionesCV';
import { estadoIncial, reductor } from './reductorResolucionesFacturaciones';

const ResolucionesFacturaciones: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaResolucionesFacturacionesCV />
        <FormularioResolucionesFacturacionesCV />
    </ProveedorEstado>
);

export default ResolucionesFacturaciones;
